import React, { useState, useEffect } from 'react';
import PhoneNumberDialog from '../dialogs/PhoneNumberDialog';
import OdvvChangeOverDialog from '../dialogs/OdvvChangeOverDialog';
import { getMarkDown, useDetectIOS,useDetectAndroid } from '../utils';
import '../../../stylesheets/triagebot/SummaryOptions.scss';
import InfoButton from './InfoButton.js';
import { datadogRum } from '@datadog/browser-rum';


const SummaryCauses = ({ message,setToastMessage, sendMessage, disabled, setSubmitted, HoverColor , locale}) => {
    const [selected, setSelected] = useState('');
    const [buttonValue, setButtonValue] = useState('');
    const [openPhoneNumberDialog, setOpenPhoneNumberDialog] = useState(false);
    const [editing, setEditing] = useState(false);
    const [Isloading,setIsLoading] = useState(false);
    const [openOdvvDialog, setOpenOdvvDialog] = useState(false);
    const [odvvPromptMessage, setOdvvPromptMessage] = useState(null);
    const [pendingOdvvValue, setPendingOdvvValue] = useState('');

    const {isIOS} = useDetectIOS();
    const {isAndroid} = useDetectAndroid();

    const recLabel = message?.data?.[2]?.summaryCardContent?.recommendedHeaderText
        ? message.data[2].summaryCardContent.recommendedHeaderText
        : '';

    const header = message.data[2].summaryCardContent.careTypeHeader
        ? message?.data?.[2]?.summaryCardContent?.careTypeHeader
        : '';

    const isDisabled = disabled;

    const triageLevel = message?.data?.[0]?.triageMapping?.triagelevel
        ? message.data[0].triageMapping.triagelevel.toLowerCase()
        : 'unknown';

    const formatCode = message?.data?.[0]?.FormatCode
        ? message.data[0].FormatCode.toLowerCase()
        : 'unknown';

    const infoMean = message.data[2].summaryCardContent.infoHeader
    ? message?.data?.[2]?.summaryCardContent?.infoHeader
    : 'What does this mean?';

    const hasSlots = message?.data?.[0]?.hasSlots
        ? message.data[0].hasSlots
        : false;

    const questionId = message?.data?.[0]?.question_id
        ? message.data[0].question_id
        : -1;

    // Recommend eVisit if no virtual visit slot available
    const recTriageLevel = ((triageLevel === 'virtual_care') && !hasSlots)
        ? 'evisit'
        : triageLevel;

    const phoneCardData = message && message.data && message.data.filter(data => { return data && data.type === 'phoneNumberCard' });

    const phoneCardMessage = phoneCardData.length
        ? phoneCardData[0]
        : {
            type: "phoneNumberCard",
            text: "",
            data: []
        };

    const buttons = message?.data?.[2].careOptionsData?.careOptions
        ? message.data[2].careOptionsData.careOptions
        : [];

    const cdoName = message?.data[0]?.cdoName;

    const buttonPress = (button) => {
        setSelected(button.value);

            if ((cdoName==='Atrius') && (['virtualcare', 'inperson', 'urgentcare'].includes(button.value.toLowerCase()))) {
                setIsLoading(true);
            }
            else if ((cdoName==='Reliant') && (['virtualcare', 'inperson'].includes(button.value.toLowerCase()))) {
                setIsLoading(true);
            }
            else if ((button.value.toLowerCase() === 'odvv' && summaryChangeoverPrompt) && (cdoName==='OptumWashington' || cdoName==='NWest')) {
                document.activeElement?.blur();
                setPendingOdvvValue(button.value);
                setOdvvPromptMessage(summaryChangeoverPrompt);
                setTimeout(() => setOpenOdvvDialog(true), 0);
                setIsLoading(false);
                return;
            }
            else if ((button.value.toLowerCase() === 'odvv' && summaryChangeoverPrompt===null) && (cdoName==='OptumWashington' || cdoName==='NWest')) {
                setIsLoading(true);
            }
         datadogRum.setViewContextProperty('careType', button.value);
         datadogRum.setViewContextProperty('recommended', button.recommended);
         datadogRum.addAction(button.recommended?"recommended":"not-recommended");        

            setTimeout(() => {
                const recommendedButtons = document.querySelectorAll('.primary-recommended');
                recommendedButtons.forEach(btn => btn.classList.remove('primary-recommended'));               
            }, 0); // Use timeout to wait for React to render

            if (button.value.toLowerCase() === 'contactme' && cdoName?.toLowerCase() !== 'optumwashington') {
                setButtonValue(button.value);
                setOpenPhoneNumberDialog(true)
                return;
            }

            // Handle urgent care deep link for Washington market (Epic MyChart "On My Way")
            if (button.value.toLowerCase() === 'urgentcare' && (button.redirectUrl || button.iOSRedirectUrl)) {
                let redirectUrl;

                if (isIOS && button.iOSUrgentCareURL) {
                    // For iOS iPhone/iPad
                    redirectUrl = button.iOSUrgentCareURL;
                } 
                else if (isAndroid && button.androidUrgentCareURL) {
                     // For Android Phone/Tab
                    redirectUrl = button.androidUrgentCareURL;
                } else {
                    // Fallback to button.redirectUrl if no platform-specific URL is available
                    redirectUrl = button.redirectUrl;
                }

                console.log('Redirecting to MyChart On My Way:', redirectUrl);

                // Use window.location.href for deep links (iOS) or window.open for web URLs
                if (isIOS||isAndroid) {
                    window.location.href = redirectUrl;
                } else {
                    window.open(redirectUrl, '_blank');
                }
            }

        setSubmitted(true);        
        let value = button.value || 'none';

        editing
            ? sendMessage('message', `##edit@${questionId}@${value}`, `##edit@${questionId}@${value}`)
            : sendMessage('message', value, value);
    }

    const clearSelection = () => {
        setSelected('');
        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    }

    useEffect(() => {
        if (message.unsubmit) {
            setSelected('');
            setSubmitted(false);            
            setEditing(true);
            message.unsubmit = false;
        }
    })   

    const summaryChangeoverPrompt = message?.data?.[2]?.changeOverPrompt || null;

    const handleOdvvContinue = () => {
        const value = pendingOdvvValue || 'odvv';
        setSubmitted(true);

        editing
            ? sendMessage('message', `##edit@${questionId}@${value}`, `##edit@${questionId}@${value}`)
            : sendMessage('message', value, value);

        setPendingOdvvValue('');
        setOdvvPromptMessage(null);
    };

    const handleOdvvCancel = () => {
        // Must stay on summary card and send nothing to bot.
        setSelected('');
        setPendingOdvvValue('');
        setOdvvPromptMessage(null);
    };

    return (
        <>
        {
            buttons.length!==0
            ? 
                <div className='options'>
                    <div className={(isDisabled ? 'disableColor' : '')} >
                    <div className={'header ' + formatCode} tabIndex={isDisabled?"-1":"0"}>
                        <h2 className='headerText' >{getMarkDown(header)}</h2>
                    </div>

                    {
                        buttons.map((button, index) => {
                            const explication_text = button.explication?.text
                            let recoBtnIndex=-1;
                            if(button.recommended){
                                recoBtnIndex=index;
                                datadogRum.setViewContextProperty("Recommended-Care",button.value)

                            }
                            return (button.value.toLowerCase() === 'VirtualCare' && !hasSlots) ||
                                (
                                    <div key={button.value} className="option-row">
                                        <div className="option-main">
                                        {
                                            (button.recommended) &&
                                            <div className={isDisabled ? ((button.value.toLowerCase()==='selfcare' && locale === 'en-US') ? 'disabled recommended-tab-selfcare' : 'disabled recommended-tab') : (( button.value.toLowerCase() === 'selfcare' && locale === 'en-US') ? 'recommended-tab-selfcare' : 'recommended-tab')}>
                                                {recLabel}
                                            </div>
                                        }
                                        {/* secondary-button-color  */}
                                        <button  data-name={button.value}  key={index}
                                            className={(button.recommended?'primary-recommended ':'')+((selected === button.value) ? 'selected single-select btn-inline' : 'single-select btn-inline')}
                                            onClick={(e) => {buttonPress(button);button.recommended?datadogRum.setViewContextProperty("isRecommendedSelected",button.recommended?"recommended":"not-recommended"):datadogRum.addAction(button.recommended?"recommended":"not-recommended")}}
                                            disabled={isDisabled}
                                        >
                                            <input type="radio" name="care-type" style={{display: 'none'}} id={button.displayText.toLowerCase()} /> 
                                            <label htmlFor={button.displayText.toLowerCase()}>{button.displayText}</label>
                                        </button>
                                        </div>
                                        {
                                         (button.explication && explication_text !== '') && 
                                            <InfoButton
                                                disabled={isDisabled}
                                                header={infoMean}
                                                ariaText={button.displayText}
                                                explication={explication_text}
                                                onShowInfo={setToastMessage}
                                            />
                                        }
                                    </div>
                                )
                        })
                    }

                    <PhoneNumberDialog
                        open={openPhoneNumberDialog}
                        setOpen={setOpenPhoneNumberDialog}
                        message={phoneCardMessage}
                        sendMessage={sendMessage}
                        clearParentSelection={clearSelection}
                        setSubmitted={setSubmitted}
                        value={buttonValue}
                        disabled={disabled}
                        HoverColor={HoverColor}
                    />
                    <OdvvChangeOverDialog
                        open={openOdvvDialog}
                        setOpen={setOpenOdvvDialog}
                        message={odvvPromptMessage}
                        onContinue={handleOdvvContinue}
                        onCancel={handleOdvvCancel}
                    />
                    {
                        Isloading && <div className="loader">
                        <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                        </div>
                    }
                </div >
                </div>
            :
            <></>
        }
        </>
    );
};

export default SummaryCauses;